export default __webpack_public_path__ + "static/media/favicon.5fbb34bb.ico";